import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import ButtonView from "@/views/ButtonView";
import IconView from "@/views/IconView";
import InformationView from "@/views/InformationView";
import CardView from "@/views/CardView";
import LoginView from "@/views/LoginView";
import RegisterView from "@/views/RegisterView";
import CollapsibleView from "@/views/CollapsibleView";
import VerificationView from "@/views/VerificationView";
import CompletedView from "@/views/CompletedView";
import LeadListView from "@/views/LeadListView";
import JournalView from "@/views/JournalView";
import PipelineView from "@/views/PipelineView";
import ProfileView from "@/views/ProfileView";
import TabsView from "@/views/TabsView";
import GroupProfileView from "@/views/GroupProfileView";
import AssignmentView from "@/views/AssignmentView";
import MarketplaceAdministrationView from "@/views/MarketplaceAdministrationView";
import KpiView from "@/views/KpiView";
import SalesFunnelView from "@/views/SalesFunnelView";
import TopListView from "@/views/TopListView";
import MarkdownEditorView from "@/views/MarkdownEditorView";

const routes = [
  {
    path: '/',
    name: 'ButtonView',
    component: ButtonView
  },
  {
    path: '/information-view',
    name: 'InformationView',
    component: InformationView
  },
  {
    path: '/icon-view',
    name: 'IconView',
    component: IconView
  },
  {
    path: '/card-view',
    name: 'CardView',
    component: CardView
  },
  {
    path: '/login-view',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/register-view',
    name: 'RegisterView',
    component: RegisterView
  },
  {
    path: '/verification-view',
    name: 'VerificationView',
    component: VerificationView
  },
  {
    path: '/completed-view',
    name: 'CompletedView',
    component: CompletedView
  },
  {
    path: '/collapsible-view',
    name: 'CollapsibleView',
    component: CollapsibleView
  },
  {
    path: '/lead-list-view',
    name: 'LeadListView',
    component: LeadListView
  },
  {
    path: '/journal-view',
    name: 'JournalView',
    component: JournalView
  },
  {
    path: '/pipeline-view',
    name: 'PipelineView',
    component: PipelineView
  },
  {
    path: '/profile-view',
    name: 'ProfileView',
    component: ProfileView
  },
  {
    path: '/tabs-view',
    name: 'TabsView',
    component: TabsView
  },
  {
    path: '/group-profile-view',
    name: 'GroupProfileView',
    component: GroupProfileView
  },
  {
    path: '/assignment-view',
    name: 'AssignmentView',
    component: AssignmentView
  },
  {
    path: '/marketplace-administration-view',
    name: 'marketplaceAdministrationView',
    component: MarketplaceAdministrationView
  },
  {
    path: '/kpi-view',
    name: 'KpiView',
    component: KpiView
  },
  {
    path: '/salesfunnel-view',
    name: 'SalesFunnelView',
    component: SalesFunnelView
  },
  {
    path: '/top-list-view',
    name: 'TopListView',
    component: TopListView
  },
  {
    path: '/markdown-editor-view',
    name: 'MarkdownEditorView',
    component: MarkdownEditorView
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
